const INITIAL_STATE = {
  items: [],
  didInvalidate: true,
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
};

module.exports = function OfferReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case 'LOGIN_SUCCESSFUL':
    case 'SET_LANGUAGE':
    case 'INVALIDATE_OFFERS':
      return {
        ...state,
        didInvalidate: true,
      };
    case 'LOGOUT_SUCCESSFUL':
      return {
        items: state.items.map((offer) =>
          Object.assign(offer, { completed: false }),
        ),
      };
    case 'FETCH_OFFERS_IN_PROGRESS': {
      return {
        ...state,
        fetchingInProgressSince: action.timestamp,
      };
    }
    case 'FETCH_OFFERS_SUCCESSFUL':
      return {
        ...state,
        didInvalidate: false,
        fetchingInProgressSince: null,
        lastSuccessfulFetch: action.timestamp,
        items: action.offers,
      };
    case 'FETCH_TAKEN_OFFERS_SUCCESSFUL':
      return {
        ...state,
        items: state.items.map((offer) => {
          if (action.offers.indexOf(offer._id) !== -1) {
            return Object.assign(offer, { completed: true });
          }
          return offer;
        }),
      };
    case 'TAKE_UP_ON_OFFER_SUCCESSFUL':
      return {
        ...state,
        items: state.items.map((offer) => {
          if (offer._id === action.offerId) {
            return { ...(action.offer || offer), completed: true };
          }
          return offer;
        }),
      };
    case 'FETCH_OFFERS_FAILED':
      return {
        ...state,
        fetchingInProgressSince: null,
        lastFailedFetch: action.timestamp,
        lastErrorMessage: action.reason,
      };
    default:
      return state;
  }
};
